import React from "react";
import { Alert, Box, Chip, Typography } from "@mui/material";
import ImportarPlanilhaDialog, { formatTelefone } from "../../components/ImportarPlanilhaDialog";
import { UsuarioDistribuidorService } from "../../service/usuario_distribuidor_service";
import { baixarModeloImportacaoUsuarios, lerPlanilhaUsuarios } from "../../utils/importacaoUsuarios";

const formatData = (iso) => {
	const m = String(iso || "").match(/^(\d{4})-(\d{2})-(\d{2})/);
	return m ? `${m[3]}/${m[2]}/${m[1]}` : iso || "-";
};

const COLUNAS_PREVIA = [
	{ rotulo: "Nome", render: (l) => <Typography variant="body2" sx={{ fontWeight: 500 }}>{l.dados.nome || "-"}</Typography> },
	{ rotulo: "E-mail", render: (l) => l.dados.email || "-" },
	{ rotulo: "Telefone", sx: { whiteSpace: "nowrap" }, render: (l) => formatTelefone(l.dados.telefone) },
	{ rotulo: "Nascimento", sx: { whiteSpace: "nowrap" }, render: (l) => formatData(l.dados.dataNascimento) },
	{
		rotulo: "Unidades",
		render: (l) =>
			(l.dados.unidades || []).length ? (
				<Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
					{l.dados.unidades.map((u) => (
						<Chip key={u.id} size="small" label={u.nome} variant="outlined" sx={{ borderColor: "#dfe3e8", color: "#0f4557" }} />
					))}
				</Box>
			) : (
				"-"
			),
	},
];

/**
 * Importação de usuários da distribuidora por planilha. Cada usuário criado
 * recebe por e-mail o login e a senha, como no cadastro manual.
 */
function ImportarUsuariosDialog({ open, onClose, onImportado, unidadeDistribuidoraId }) {
	const service = new UsuarioDistribuidorService();
	return (
		<ImportarPlanilhaDialog
			open={open}
			onClose={onClose}
			onImportado={onImportado}
			titulo="Importar usuários de planilha"
			entidade={{ singular: "usuário", plural: "usuários", contagem: "usuário(s)" }}
			instrucoes={
				<>
					<Typography variant="body2" sx={{ color: "#5a7a88" }}>
						Colunas obrigatórias: <strong>Nome</strong>, <strong>E-mail</strong>, <strong>Telefone</strong> (celular com
						DDD) e <strong>Data de nascimento</strong> (dd/mm/aaaa). Só é possível cadastrar usuários com 18 anos ou mais.
					</Typography>
					<Typography variant="body2" sx={{ color: "#5a7a88" }}>
						Em <strong>Unidades</strong> (opcional), separe por ponto e vírgula os nomes das unidades como estão no
						sistema. Sem essa coluna, o usuário fica vinculado à unidade aberta agora.
					</Typography>
					<Typography variant="body2" sx={{ color: "#5a7a88" }}>
						Usuários com e-mail já cadastrado na empresa não são duplicados. Cada usuário novo recebe login e senha
						por e-mail, e a importação respeita a quantidade de usuários da licença.
					</Typography>
				</>
			}
			ler={lerPlanilhaUsuarios}
			baixarModelo={baixarModeloImportacaoUsuarios}
			previa={(linhas) => service.previaImportacao(unidadeDistribuidoraId, linhas)}
			importar={(linhas) => service.importar(unidadeDistribuidoraId, linhas)}
			colunas={COLUNAS_PREVIA}
			textoAvisos="Algumas linhas têm avisos (em laranja): o usuário entra, mas a unidade citada fica de fora. Você pode ajustar as unidades depois no cadastro do usuário."
			alertasExtras={(previa) => (
				<Alert severity="info">
					A licença ainda aceita <strong>{previa.resumo.vagas}</strong> usuário(s).
					{previa.linhas.some((l) => l.motivo === "Limite de usuários da licença atingido") &&
						" As linhas que passaram do limite estão marcadas com erro e não serão importadas."}
				</Alert>
			)}
		/>
	);
}

export default ImportarUsuariosDialog;
